import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { paramParsify } from "utils/queryParams";
import { useGetReportList } from "./service/ReportsService";
import { InputYearPickerComponent, Title } from "components";
import { downloadUrl } from "utils/linkDownload";
import storage from "services/storage";
import dayjs from "dayjs";

const ReportsPage = ({ setLayoutAction }) => {
  const location = useLocation();
  const companyIdLocalStorage = storage.getCompanyID();

  // render custom action in title layout
  useEffect(() => {
    const parsedQueryParams = paramParsify(location?.search);

    setLayoutAction(
      <InputYearPickerComponent
        value={parsedQueryParams?.year || "All time"}
        limitToFiveYears={true}        
      />,
    );

    return () => {
      setLayoutAction(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const { response } = useGetReportList({ id: companyIdLocalStorage });
  const reports = useMemo(
    () =>
      (response?.data?.reports ?? [])?.reduce((prevObj, currentValue) => {
        const year = currentValue?.period?.split(" ")?.[1];
        return {
          ...prevObj,
          [year]: !prevObj?.[year]
            ? [currentValue]
            : [...prevObj?.[year], currentValue],
        };
      }, {}),
    [response],
  );

  return (
    <div className='reports-page grid gap-4'>
      {Boolean(Object.keys(reports)?.length) ? (
        Object.keys(reports)
          ?.sort((a, b) => b - a)
          ?.map((title, idx) => (
            <div className='pb-10' key={`${title}-${idx}`}>
              <Title title={title} />
              <div className='grid grid-cols-1 gap-4 pt-5 md:grid-cols-2 xl:grid-cols-3' spacing={2}>
                {reports?.[title]?.map((report, reportIdx) => (
                  <div
                    key={`${title}-${idx}-${reportIdx}`}
                    className='section !h-auto min-h-[96px] min-w-0 !p-[14px]'
                  >
                    <div className='flex min-w-0 items-start justify-between gap-3'>
                      <div className='flex min-w-0 flex-1 items-start gap-4'>
                        <img className='shrink-0' alt='report-icon' src='/images/report-icon.svg' />
                        <div className='flex min-w-0 flex-1 flex-col gap-1'>
                          <span className='break-words text-[14px] font-semibold leading-snug'>{`Monthly Report - ${report?.period}`}</span>
                          <span className='break-words text-[12px] leading-5 text-[#5F737F]'>{`Uploaded on ${dayjs(
                            report?.uploaded_date,
                          ).format("MMM DD, YYYY")}`}</span>
                        </div>
                      </div>
                      <img
                        className='cursor-pointer shrink-0'
                        alt='report-download-icon'
                        src='/images/report-download-icon.svg'
                        onClick={() => {
                          downloadUrl(report?.document_url);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
      ) : (
        <div className='mt-20 flex items-center justify-center'>
          <img
            alt='table-empty-icon'
            src='/images/report-empty.svg'
            className='m-auto'
          />
        </div>
      )}
    </div>
  );
};

export default ReportsPage;
